export const Layout = ({ children }) => {
    return (
        <div className="bg-white-300 min-h-screen">
            {children}
        </div>
    );
}